import React, { useCallback, useState } from 'react';
import NumberInput from './NumberInput';

const LOSS_CAP_MIN = 0;
const LOSS_CAP_MAX = 100000;

interface CapitalLossDeductionCapInputProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

const formatUsd = (value: string) => {
  const parsed = Number(value);
  const safeValue = Number.isFinite(parsed) ? parsed : 0;
  return `$${safeValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const formatWhileEditing = (value: string) => `$${value}`;

const sanitize = (value: string) => {
  const digitsAndDot = value.replace(/[^\d.]/g, '');
  const dotIndex = digitsAndDot.indexOf('.');
  if (dotIndex === -1) return digitsAndDot;
  return digitsAndDot.slice(0, dotIndex + 3);
};

const clipWithinRange = (value: number) => Math.min(LOSS_CAP_MAX, Math.max(LOSS_CAP_MIN, value));

export const CapitalLossDeductionCapInput = ({ value, onChange, disabled }: CapitalLossDeductionCapInputProps) => {
  const [focused, setFocused] = useState(false);

  const onFocus = useCallback(() => setFocused(true), []);
  const onBlur = useCallback(() => setFocused(false), []);

  return (
    <NumberInput
      hideSteppers
      label="Capital Loss Deduction Cap"
      disabled={disabled}
      controlled
      value={value}
      precision={2}
      step={0.01}
      min={LOSS_CAP_MIN}
      max={LOSS_CAP_MAX}
      formatter={focused ? formatWhileEditing : formatUsd}
      parser={sanitize}
      width={100}
      height={35}
      onChange={(newValue) => onChange(clipWithinRange(newValue))}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
};
